import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class ProactiveDrugSearchType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    this._categories = init.categories
    this._employee_id = init.employee_id
    this._id = init.id
    this._pds_drug_info = init.pds_drug_info
    this._pds_member = init.pds_member
    this._pds_pharmacy = init.pds_pharmacy
    this._pds_plan_info = init.pds_plan_info
  }

  static shape = {
    categories: PropTypes.string,
    employee_id: PropTypes.number,
    id: PropTypes.number,
    pds_drug_info: PropTypes.object,
    pds_member: PropTypes.object,
    pds_pharmacy: PropTypes.object,
    pds_plan_info: PropTypes.object
  }

  get categories() {
    return this._categories
  }

  get employee_id() {
    return this._employee_id
  }

  get id() {
    return this._id
  }

  get pds_drug_info() {
    return this._pds_drug_info
  }

  get pds_member() {
    return this._pds_member
  }

  get pds_pharmacy() {
    return this._pds_pharmacy
  }

  get pds_plan_info() {
    return this._pds_plan_info
  }
}

export default ProactiveDrugSearchType
